module.exports = __webpack_public_path__ + "static/Momentum---red-on-white-232c6636f0ec93d9a94b02820b22a2cb.png";